import React from 'react';
import classNames from 'classnames';

import './styles.css';

const UppercaseText = ({children, className}: any) => (
  <span className={classNames('UppercaseText', className)}>{children}</span>
);

export default UppercaseText;
